import clsx from 'clsx';
import { NavItems } from './NavItems';
import type { NavSection } from './Sidebar.types';

export const NavSections = ({
  section,
  isCollapsed,
  onItemClick,
}: {
  section: NavSection;
  isCollapsed: boolean;
  onItemClick?: () => void;
}) => {
  return (
    <div className='space-y-1'>
      {/* Section title: always show on mobile, hide on desktop when collapsed */}
      {section.title && (
        <h3
          className={clsx(
            'mb-2 px-3 text-xs font-semibold tracking-wider text-gray-400 uppercase',
            isCollapsed && 'lg:hidden'
          )}
        >
          {section.title}
        </h3>
      )}
      {/* Divider: only show on desktop when collapsed */}
      {section.title && isCollapsed && (
        <div className='mx-3 my-2 hidden h-px bg-gray-200 lg:block' />
      )}
      {section.items.map(item => (
        <NavItems key={item.path} item={item} isCollapsed={isCollapsed} onClick={onItemClick} />
      ))}
    </div>
  );
};
